import { useMemo } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { settingsClasses } from '../utility/constants';
import useThemeVal from '../../utility/useThemeVal';
import useToken from '../../utility/useToken';
import { failsTokenAndSetupCheck } from '../../checks/setup';

const title = 'Settings';

const devMsg = 'This site is under development...';

export default function Settings(props) {
  const currDarkThemeClass = useThemeVal();

  // const {token} = getTokenDetails();
  const { token, tokenDetails } = useToken();

  const invalidTokenState = useMemo(() => failsTokenAndSetupCheck(token, tokenDetails), [token]);

  if (invalidTokenState) return <></>;

  const settingsBoxProps = {
    className: `${settingsClasses?.box} ${currDarkThemeClass} customScroll`,
  };

  const settingsTitleTypoProps = {
    className: `${settingsClasses?.titleTypo} ${currDarkThemeClass}`,
  };

  const devTypoProps = {
    className: `${settingsClasses?.devTypo} ${currDarkThemeClass}`,
  };

  return (
    <Box {...settingsBoxProps}>
      <Typography {...settingsTitleTypoProps}>{title}</Typography>

      <Typography {...devTypoProps}>{devMsg}</Typography>
    </Box>
  );
}
